import { Injectable } from "@angular/core";
import { IGeojsonRequest } from "app/bundles/requests/shared/models/geojsonRequest";
import { IWorkorderOrServiceRequestSummary } from "app/bundles/requests/shared/models/request";
import { Service } from "app/bundles/requests/shared/models/service";
import { FilterService } from "app/bundles/requests/shared/services/filter.service";
import { UtilService } from "app/bundles/requests/shared/services/util.service";
import { CoreService } from "app/core/core.service";
import * as _ from "lodash-es";

@Injectable()
export class StorageService {
  private requests: IWorkorderOrServiceRequestSummary[] = [];
  private services: Service[] = [];
  private geoJsonRequest: IGeojsonRequest;
  private mapStatus: any = {};

  constructor(
    private filterService: FilterService,
    private coreService: CoreService,
    private utilService: UtilService,
  ) {}

  setGeoJsonRequest(geoJsonRequest: IGeojsonRequest): void {
    const emptyGeoJsonRequest = {
      type: "FeatureCollection",
      features: [],
    };
    if (!geoJsonRequest?.type || !geoJsonRequest?.features) {
      this.geoJsonRequest = emptyGeoJsonRequest;
      return;
    }
    this.geoJsonRequest = geoJsonRequest;
  }

  getGeoJsonRequest(): IGeojsonRequest {
    return this.geoJsonRequest;
  }

  notifyComponents() {
    this.requests = this.utilService.getRequestsFromGeojson(
      this.getGeoJsonRequest(),
    );
    if (this.getGeoJsonRequest()) {
      this.services = this.filterService.findServices(this.getGeoJsonRequest());
    } else {
      this.services = [];
    }
  }

  notifyMap() {
    this.coreService.notifyMapUpdate(this.getGeoJsonRequest());
  }

  notifyList() {
    this.coreService.notifyHandlerEventUpdate();
  }

  setLastGeoJsonRequest(geoJsonRequest: IGeojsonRequest): void {
    sessionStorage.setItem(
      "lastGeoJsonRequest",
      JSON.stringify(geoJsonRequest),
    );
  }

  getLastGeoJsonRequest(): IGeojsonRequest {
    const rawLastGeoJsonRequest = sessionStorage.getItem("lastGeoJsonRequest");
    if (rawLastGeoJsonRequest === "undefined") {
      return undefined;
    }
    return <IGeojsonRequest>JSON.parse(rawLastGeoJsonRequest);
  }

  setRequests(requests: IWorkorderOrServiceRequestSummary[]): void {
    this.requests = requests;
  }

  getRequests(): IWorkorderOrServiceRequestSummary[] {
    return this.requests;
  }

  setAuthorizationToken(authorizationToken: string): void {
    if (authorizationToken) {
      localStorage.setItem("authorizationToken", authorizationToken);
    }
  }

  getAuthorizationToken(): string {
    return localStorage.getItem("authorizationToken");
  }

  setServices(services: Service[]): void {
    this.services = services;
  }

  getServices(): Service[] {
    return this.services;
  }

  setIsFirstLoad(isFirstLoad: boolean): void {
    sessionStorage.setItem("isFirstLoad", isFirstLoad.toString());
  }

  isFirstLoad(): boolean {
    return sessionStorage.getItem("isFirstLoad") === null;
  }

  setFilters(filters: object) {
    sessionStorage.setItem("filters", JSON.stringify(filters));
  }

  getFilters() {
    const emptyFilter = `{"listType":3,"searchTerm":"","serviceCode":"","statusCode":"","responsibleUser":"","responsibleGroup":""}`;
    return JSON.parse(sessionStorage.getItem("filters") || emptyFilter);
  }

  updateFilters(key: string, value: string) {
    const filters = this.getFilters();
    _.set(filters, key, value);
    this.setFilters(filters);
  }

  setMapStatus(mapStatus: any) {
    this.mapStatus = mapStatus;
  }

  getMapStatus(): any {
    return this.mapStatus;
  }

  public enabledTracking(id: string): void {
    sessionStorage.setItem("selectedRequestId", id.toString());
  }

  public getTrackedRequestId(): string {
    return sessionStorage.getItem("selectedRequestId");
  }

  public disabledTracking(): void {
    sessionStorage.removeItem("selectedRequestId");
  }

  public savePositionList(id: string): void {
    sessionStorage.setItem("cursorRequestId", id.toString());
  }

  public getPositionList(): string {
    return sessionStorage.getItem("cursorRequestId");
  }

  public restorePositionList(): void {
    sessionStorage.removeItem("cursorRequestId");
  }
}
